import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/cancel.svg'


const _hoisted_1 = {
  key: 0,
  class: "applied-chips"
}
const _hoisted_2 = ["title"]
const _hoisted_3 = { class: "chip-label" }
const _hoisted_4 = { class: "chip-value" }
const _hoisted_5 = ["aria-label", "onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.chips.length)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _cache[1] || (_cache[1] = _createElementVNode("span", { class: "applied-chips-heading" }, "Applied Filters:", -1)),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.chips, (chip) => {
          return (_openBlock(), _createElementBlock("span", {
            key: chip.key,
            class: "applied-filter-chip",
            title: chip.fullValue || chip.value
          }, [
            _createElementVNode("span", _hoisted_3, _toDisplayString(chip.label) + ":", 1),
            _createElementVNode("span", _hoisted_4, _toDisplayString(chip.value), 1),
            _createElementVNode("button", {
              type: "button",
              class: "applied-filter-remove",
              "aria-label": 'Remove ' + chip.label + ' filter',
              onClick: ($event: any) => (_ctx.$emit('remove', chip.key))
            }, _cache[0] || (_cache[0] = [
              _createElementVNode("img", {
                src: _imports_0,
                alt: ""
              }, null, -1)
            ]), 8, _hoisted_5)
          ], 8, _hoisted_2))
        }), 128))
      ]))
    : _createCommentVNode("", true)
}